// src/services/sponsoredBanner.service.js
import sponsoredBannerMockResponse from "../mocks/sponsoredBanner.mock";

const USE_MOCK = process.env.REACT_APP_USE_MOCK_ADS !== "false";
const DEFAULT_ENDPOINT = "/api/sponsored-banners";

function normalizeResponse(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.data?.data)) return response.data.data;
  return [];
}

export async function fetchSponsoredBanners({ signal } = {}) {
  if (USE_MOCK) {
    return sponsoredBannerMockResponse.data;
  }

  const response = await fetch(DEFAULT_ENDPOINT, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
    signal,
  });

  if (!response.ok) {
    throw new Error("Failed to fetch sponsored banners");
  }

  const json = await response.json();
  return normalizeResponse(json);
}